import React from 'react';
import { css } from '@emotion/css';
import { campaigns } from '../../../../../../common/campaigns';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  link: css`
    font-size: 14px;
    display: flex;
    align-items: center;

    i {
      margin-right: 8px;
      font-size: 16px;
    }
  `,
};

export const OverviewDescription = ({ isEntitled }: { isEntitled: boolean }) => {
  const { t } = useIntl();

  return (
    <div>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.billCheckV3.modal.overview.title'
          defaultMessage='Geld von Vermieter:innen zurück mit dem Nebenkosten Schnell-Check'
        />
      </div>
      <div className='padding-bottom-l'>
        <Msg
          id='benefits.billCheckV3.modal.overview.paragraph1'
          defaultMessage='Viele Nebenkostenabrechnungen sind zu hoch. Lass deine Abrechnung durch die Rechtsexpert:innen von Mineko prüfen und erhalte bei Fehlern Geld von deinem:deiner Vermieter:in zurück..'
        />
      </div>
      <ul className='list-check list-spacing-s'>
        <li>
          <Msg
            id='benefits.billCheckV3.modal.overview.checklist.item1'
            defaultMessage='Bequem von Zuhause als Scan oder Foto hochladen'
          />
        </li>
        <li>
          <Msg
            id='benefits.billCheckV3.modal.overview.checklist.item2'
            defaultMessage='Persönliches Prüfergebnis innerhalb von 5 Tagen von Expert:innen erhalten'
          />
        </li>
        <li>
          <Msg
            id='benefits.billCheckV3.modal.overview.checklist.item3'
            defaultMessage='Einmal im Jahr in WohnenPlus enthalten'
            values={{
              LivingPlusLogo: <PlusBadge variant='living' />,
            }}
          />
        </li>
      </ul>
      {!isEntitled && (
        <a className={`${styles.link} margin-top-l`} href={campaigns.BILLCHECK_LEARN_MORE}>
          <i className={'is24-icon-chevron-right'} />
          {t({
            id: `benefits.billCheckV3.modal.overview.discoverWohnenPlusCta`,
            defaultMessage: 'WohnenPlus entdecken',
          })}
        </a>
      )}
    </div>
  );
};
